<template>
  <el-dialog
    :title="isEdit ? '编辑用户' : '新增用户'"
    :visible="visible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="用户账号" prop="userName">
        <el-input
          v-model="form.userName"
          :disabled="isEdit"
          placeholder="请输入用户账号"
        />
      </el-form-item>

      <el-form-item label="昵称" prop="nickName">
        <el-input v-model="form.nickName" placeholder="请输入昵称" />
      </el-form-item>

      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="form.sex">
          <el-radio :label="0">保密</el-radio>
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="!isEdit" label="密码" prop="password">
        <el-input
          v-model="form.password"
          type="password"
          placeholder="请输入密码"
          show-password
        />
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="消息权限" prop="canSendMessage">
        <el-radio-group v-model="form.canSendMessage">
          <el-radio :label="true">允许发送消息</el-radio>
          <el-radio :label="false">禁止发送消息</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="过期时间" prop="expireTime">
		  {{form.expireTime}}
        <el-input
          v-model="form.expireTime"
          type="datetime-local"
          placeholder="请选择过期时间"
          style="width: 100%"
        />
        <div class="form-tip">留空表示不变</div>
      </el-form-item>

      
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createUser, updateUser } from "@/api/user";

export default {
  name: "UserForm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        userName: "",
        nickName: "",
        phone: "",
        email: "",
        sex: 0,
        password: "",
        status: 0,
        canSendMessage: false,
        expireTime: "",
        remark: "",
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户ID", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        nickName: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],

        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.userData;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.isEdit && this.userData) {
        this.form = { ...this.userData };
        // 编辑时不需要密码验证
        delete this.rules.password;
      } else {
        this.form = {
          userName: "",
          nickName: "",
          phone: "",
          email: "",
          sex: 0,
          password: "",
          status: 0,
          canSendMessage: false,
          expireTime: "",
          remark: "",
        };
        // 新增时需要密码验证
        this.rules.password = [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ];
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;

        if (this.isEdit) {
          await updateUser(this.userData.id, this.form);
          this.$message.success("更新成功");
        } else {
          await createUser(this.form);
          this.$message.success("创建成功");
        }

        this.$emit("success");
      } catch (error) {
        if (error !== false) {
          console.error("提交失败:", error);
          this.$message.error("操作失败");
        }
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
    },

    // 禁用过去的日期
    disabledDate(time) {
      // 禁用今天之前的日期
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return time.getTime() < today.getTime();
    },
  },
};
</script>

<style scoped>
.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
</style>
